import { ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';

export const GoTemplateRegEx = /{{(.*?)}}/g;

@ValidatorConstraint({ name: 'GoTemplate' })
export class GoTemplateValid implements ValidatorConstraintInterface {
  validate(currentValue: string) {
    return GoTemplateRegEx.test(currentValue);
  }

  defaultMessage() {
    return 'Please enter a valid dynamic template';
  }
}
